import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import PermissionCheck from '../../Utilities/PermissionCheck';
import { Permission } from '../../Permissions/Permissions';
import Button from '@mui/material/Button';
import { ResponseType, TokenRefreshContext } from '../../Contexts/TokenRefreshContext';
import authService from '../../api-authorization/AuthorizeService';
import ActionViewmodel from '../Viewmodels/ActionViewmodel';
import ChangeDialog from '../../Utilities/ChangeDialog';
import Grid from '@mui/material/Grid';

interface IProps {
    row: ActionViewmodel;
    refresh: () => void;
}

export default function ActionsTableRow(props: IProps) {
    const { row, refresh } = props;
    const { crabFetch } = React.useContext(TokenRefreshContext);
    const [outcome, setOutcome] = React.useState('');
    const [openComplete, setOpenComplete] = React.useState(false);
    const [openComment, setOpenComment] = React.useState(false);

    React.useEffect(() => {
        setOutcome(row.outcome ?? '');
    }, [row]);

    const markComplete = async () => {
        const token = await authService.getAccessToken();

        await crabFetch(`Action/MarkComplete?id=${row.id}&outcome=${outcome}`, {
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
        }, ResponseType.Text,
            (data: any) => {
                refresh();
            },
            () => {
            }
        );
    }

    const addComment = async () => {
        const token = await authService.getAccessToken();

        await crabFetch(`Action/AddComment?id=${row.id}&outcome=${outcome}`, {
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
        }, ResponseType.Text,
            (data: any) => {
                refresh();
            },
            () => {
            }
        );
    }

    return (
        <TableRow>
            <TableCell>{row.type}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>{new Date(row.date).toLocaleDateString('en-gb')}</TableCell>
            <TableCell>{row.complete ? 'Completed' : 'Outstanding'}</TableCell>
            <TableCell>{row.outcome}</TableCell>
            <TableCell align="right">
                {!row.complete &&
                    <Grid container spacing={2} justifyContent="flex-end">
                        <PermissionCheck permission={Permission.CreateReport}>
                            <Grid item>
                                <Button variant="contained" size="small" onClick={() => setOpenComment(true)}>Add Comment</Button>
                            </Grid>
                        </PermissionCheck>
                        <PermissionCheck permission={Permission.CreateReport}>
                            <Grid item>
                                <Button variant="contained" size="small" onClick={() => setOpenComplete(true)}>Mark as Complete</Button>
                            </Grid>
                        </PermissionCheck>
                    </Grid>
                }
            </TableCell>
            <ChangeDialog
                buttonText='Save'
                text='Add comment'
                open={openComment}
                close={() => { setOpenComment(false); setOutcome(row.outcome ?? ''); }}
                changeDescription={outcome}
                setDescription={setOutcome}
                okClick={addComment}
                placeholder="Please provide details."
            />
            <ChangeDialog
                buttonText='Save'
                text='Mark action as complete'
                open={openComplete}
                close={() => { setOpenComplete(false); setOutcome(row.outcome ?? ''); }}
                changeDescription={outcome}
                setDescription={setOutcome}
                okClick={markComplete}
                placeholder="Please provide details."
            />
        </TableRow>
    );
}